import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import { Textarea } from '~/lib/ui/textarea'
import CalloutBox from '~/components/Article/CalloutBox'

const VisionStatementPageSix = () => {
  const { getResponse, exerciseIndex, handleChange, formattedExerciseName } =
    useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageSixTranslations = t('pages.5')

  const paragraphs = pageSixTranslations.paragraphs
  const examplePrompts = pageSixTranslations.example_prompts
  const visionStatementLabels = pageSixTranslations.vision_statement_labels
  const placeholder = pageSixTranslations.placeholder_vision_statement
  const exampleResponse = pageSixTranslations.example_vision_statement
  const widths = [60, '1/2', '4/5', 96, '1/2']

  return (
    <div>
      {paragraphs.map((paragraph, index) => (
        <>
          <p key={'paragraph' + index}>{paragraph}</p>
          {index === 1 && (
            <ul className="mb-6">
              {examplePrompts.map((prompt, promptIndex) => (
                <li key={promptIndex}>{prompt}</li>
              ))}
            </ul>
          )}
          {index === 2 && (
            <>
              <p>
                {visionStatementLabels.map((label, index) => (
                  <>
                    {label}
                    <textarea
                      className={`mx-2 h-9 w-${widths[index]} rounded-[5px] border border-[#D3D3D3] bg-[#F7FAFC] align-text-bottom font-roboto text-base font-normal`}
                      value={getResponse(
                        exerciseIndex,
                        `page_six_vision_statement_${index}`,
                      )}
                      onChange={(value) =>
                        handleChange(
                          exerciseIndex,
                          `page_six_vision_statement_${index}`,
                          value,
                        )
                      }
                      placeholder={placeholder[index + 1]}
                      id={`page_six_vision_statement_${index}`}
                    />
                    {index === 1 || index === 2 ? (
                      <>
                        <br />
                        <br />
                      </>
                    ) : null}
                  </>
                ))}
              </p>
              <br />
              <CalloutBox calloutObject={exampleResponse} />
              <br />
            </>
          )}
          {index === 3 && (
            <>
              <Textarea
                className="mt-6 min-h-[125px] w-full rounded-[20px] font-roboto text-base font-normal"
                value={getResponse(exerciseIndex, 'page_six_textbox')}
                onChange={(value) =>
                  handleChange(exerciseIndex, 'page_six_textbox', value)
                }
              />
            </>
          )}
        </>
      ))}
    </div>
  )
}

export default VisionStatementPageSix
